import { render, staticRenderFns } from "./UserArticles.vue?vue&type=template&id=148f59bc&"
import script from "./UserArticles.vue?vue&type=script&lang=js&"
export * from "./UserArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports